import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const affiliatedTrainersLoaded = (payload = null) => ({ type: ACTION.AFFILIATED_TRAINER_SUCCESS, payload })
export const affiliatedTrainersBase = () => ({ type: ACTION.AFFILIATED_TRAINER_BASE })
export const affiliatedTrainersLoading = () => ({ type: ACTION.AFFILIATED_TRAINER_LOADING })


export const getAffiliatedTrainers = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(affiliatedTrainersLoading())
    apiService.getDigitalCoachingTrainers('thestjames', { mini: true })
    .then(response => {
      dispatch(affiliatedTrainersLoaded(response))
      resolve(response)
    })
    .catch(error => {
      dispatch(affiliatedTrainersBase())
      reject(error)
    })
  })
}
